import clsx from 'clsx';

import { formatDate } from '../../utilities';
import MessageContent from './MessageContent';
import { checkIsComplex } from './contentCheck';
import { getMessageClassName } from './getMessageClassName';
import type { Item } from './useMessages';

type MessagesListProps = {
  data: Item[];
};

export const MessagesList: React.FC<MessagesListProps> = ({ data }) => {
  return (
    <div className="flex flex-col gap-y-lg flex-1 overflow-y-auto max-w-full">
      {data.map(message => {
        const isUser = message.author_type === 'User';
        const isComplex = checkIsComplex(message.content);

        return (
          <div
            key={message.id}
            className={clsx(
              'w-full flex',
              isUser ? 'justify-end' : 'justify-start'
            )}
          >
            <div
              className={clsx(
                isComplex ? 'w-[70%]' : 'max-w-[70%]',
                'break-all rounded-sm border-l-4 p-lg',
                getMessageClassName(message) || 'bg-bg'
              )}
            >
              <div className="text-text text-medium">
                <MessageContent
                  isComplex={isComplex}
                  content={message.content}
                />
              </div>
              <div className="mt-md text-tiny font-semibold">
                {[
                  message.conversation_channel,
                  message.author_type,
                  formatDate(message.message_timestamp),
                ]
                  .filter(Boolean)
                  .join(' • ')}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};
